import { Check, X } from "lucide-react";

interface ValidationResult {
  isValid: boolean;
  message: string;
}

interface ValidationIndicatorProps {
  validation: ValidationResult | null;
  isValidating: boolean;
}

export const ValidationIndicator = ({
  validation,
  isValidating,
}: ValidationIndicatorProps) => {
  if (isValidating) {
    return (
      <div className="validation-indicator checking">
        <span className="loading-spinner-small">...</span>
        <span>Checking availability...</span>
      </div>
    );
  }

  if (!validation) {
    return null;
  }

  return (
    <div
      className={`validation-indicator ${
        validation.isValid ? "valid" : "invalid"
      }`}
    >
      {validation.isValid ? (
        <Check size={16} className="validation-icon success" />
      ) : (
        <X size={16} className="validation-icon error" />
      )}
      <span>{validation.message}</span>
    </div>
  );
};
